import { UseCustomAxios } from "../../../UseCustomAxios";
import { useSnackbar } from "notistack";
import { isEmpty } from "../../../util/Utils";

export function UseFooterLinks() {
  const MyAxios = UseCustomAxios();
  const { enqueueSnackbar } = useSnackbar();

  function validateLink(state, imgState, setter) {
    let errorState = {
      title: isEmpty(state.title),
      url: isEmpty(state.url),
    };

    setter(errorState);

    if (errorState.title || errorState.url) {
      enqueueSnackbar("لطفا اطلاعات لینک را کامل وارد کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    } else {
      return 200;
    }
  }

  const GetFooterLinks = (callback) => {
    MyAxios.get(`Admin_Mag_HomePage/GetFooterLinks`).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const SetFooterLinks = (state, icon, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    if (icon) {
      data.append("icon", icon);
    }
    MyAxios.post(`Admin_Mag_HomePage/SetFooterLinks`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("با موفقیت انجام شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const RemoveFooterLinks = (ID, callback) => {
    const data = new FormData();
    data.append("ID", ID);
    MyAxios.delete(`Admin_Mag_HomePage/RemoveFooterLinks`, {
      data: data,
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("لینک با موفقیت حذف شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  return {
    GetFooterLinks,
    SetFooterLinks,
    RemoveFooterLinks,
    validateLink,
  };
}
